import { CHALLENGE_NULL_COLOR } from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeColorBar';
import styled from '@emotion/styled';

type ColorPreviewProps = {
  selectedColor: string | null;
};

const ColorPreview = styled('div')<ColorPreviewProps>(
  ({ theme, selectedColor }) => ({
    marginLeft: 0,
    marginRight: 10,
    width: 18,
    minWidth: 18,
    height: 18,
    backgroundColor:
      selectedColor === null || selectedColor === CHALLENGE_NULL_COLOR
        ? 'transparent'
        : selectedColor,
    border: `1px solid ${theme.palette.text.primary}`,
    borderRadius: 4,
  }),
);

export default ColorPreview;
